module.exports = __webpack_public_path__ + "static/img/dentaire-01.42b491c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dentaire-01.png
// module id = 81
// module chunks = 0